import React from "react";
import "./Choice.css";

const choice = (props) => {
  const classCurr = ["ContainerChoice"];

  if (props.active) {
    classCurr.push(["active"]);
    // props.hovered(() => props.id);
  }

  return (
    <div
      className={classCurr.join(" ")}
      onMouseOver={props.onHover}
      onClick={props.onClick}
    >
      <div className={"Choice"}>
        <p>{props.text}</p>
      </div>
    </div>
  );
};

export default React.memo(choice);
